import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { AlertContent, ModalFactory } from 'components';
import { lineHeight, theme, toRem } from 'design';
import { routeConstants } from 'routes';
import { browserHistory } from 'routes/Router';
import { selectCurrentEmployeeSite } from 'store/Employers';
import { SiteRole } from 'types';

export const AltAlertContent = styled(AlertContent)`
  h2 {
    margin-bottom: ${toRem(theme.space.lg)};
    font-size: ${toRem(theme.font.size.lg)};
    line-height: ${lineHeight(theme.font.size.lg)};
  }

  .modal-text {
    margin-bottom: 0;
  }

  button:not(:first-of-type) {
    width: 100%;
  }
`;

export const NoCalculatorRulesModal = ({ hideModal, closeOnOutSideClick = false }: { hideModal: () => void; closeOnOutSideClick?: boolean }) => {
  const currentSite = useSelector(selectCurrentEmployeeSite);

  return (
    <ModalFactory customModal onClose={hideModal} isActive closeOnOutSideClick={closeOnOutSideClick}>
      {currentSite?.role === SiteRole.ADMIN ? (
        <AltAlertContent
          hideLeftAction
          title="Tip Calculation Rules Not Configured"
          message="We couldn't find any configured rules for your tip calculator. To get started, please visit Calculator Settings and set up your rules."
          rightActionLabel="Go to Settings"
          onRightAction={() => browserHistory.push(routeConstants.private.settingsCalculator)}
        />
      ) : (
        <AltAlertContent
          hideLeftAction
          title="Tip Calculation Rules Not Configured"
          message="We couldn't find any configured rules for your tip calculator. In order to proceed, please contact your site admin to complete setting up your tip rules."
          rightActionLabel="Close"
          onRightAction={hideModal}
          rightActionAppearance="white"
        />
      )}
    </ModalFactory>
  );
};
